import Dexie, { Table } from "dexie";

export interface Template {
  id?: number;
  title: string;
  description?: string;
  fileHash: string;
  fileName: string;
  fileCreatedAt: Date;
  createdAt: Date;
}

export interface Form {
  id?: number;
  templateId: number;
  templateName: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Category {
  id?: number;
  templateId: number;
  title: string;
  sectionCount: number;
}

export interface Section {
  id?: number;
  templateId: number;
  categoryId: number;
  title: string;
  itemCount: number;
}

export interface Item {
  id?: number;
  templateId: number;
  sectionId: number;
  title: string;
  taskCount: number;
}

export interface Task {
  id?: number;
  templateId: number;
  itemId: number;
  prefix: string | null;
  content: string | null;
  status: "valid" | "invalid" | null;
}

export interface TaskOverride {
  id?: number;
  formId: number;
  taskId: number;
  status: "valid" | "invalid" | null;
}

export interface Photo {
  id?: number;
  formId: number;
  taskId: number;
  date: Date;
  file: File;
}

export interface Recording {
  id?: number;
  formId: number;
  taskId: number;
  date: Date;
  blob: Blob;
}

export class Database extends Dexie {
  templates!: Table<Template, number>;
  forms!: Table<Form, number>;
  categories!: Table<Category, number>;
  sections!: Table<Section, number>;
  items!: Table<Item, number>;
  tasks!: Table<Task, number>;
  taskOverrides!: Table<TaskOverride, number>;
  recordings!: Table<Recording, number>;
  photos!: Table<Photo, number>;

  constructor() {
    super("CheckIt", {});
    this.version(1).stores({
      templates: "++id, title, fileHash, createdAt",
      forms: "++id, templateId, createdAt, updatedAt",
      categories: "++id, templateId, formId, title",
      sections: "++id, templateId, formId, categoryId, title",
      items: "++id, templateId, formId, sectionId, title",
      tasks: "++id, templateId, formId, itemId, title",
      recordings: "++id, [formId+taskId], formId, taskId, date",
      photos: "++id, [formId+taskId], formId, taskId, date",
      taskOverrides: "++id, [formId+taskId], formId, taskId",
    });
  }
}

export const database = new Database();
